import styled, { css } from 'styled-components';
export const HintBase = styled.div.attrs({
    className: 'hint',
}) `
  & > p {
    font-size: 14px;
    line-height: 24px;
  }

  & > button {
    font-size: 14px;
    line-height: 24px;
    border: none;
    color: inherit;
    background: transparent;
    text-decoration: underline;

    padding: 0;
    cursor: pointer;
  }

  & > button:focus {
    outline: var(--outline);
    outline-offset: 4px;
  }
  & > button:focus:not(:focus-visible) {
    outline: 0;
  }
  & > button:focus-visible {
    outline: var(--outline);
    outline-offset: 4px;
  }
`;
export const Text = styled.p `
  margin: 0;

  & > a {
    font-size: inherit;
  }

  ${({ $lines, $open, $maxLines }) => $lines !== 0 &&
    !$open &&
    css `
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${$maxLines};
      -webkit-box-orient: vertical;
    `}
`;
